<template>
    <div>
        <el-table :data="unitList" :empty-text="i18n.tkey('lang_temporary_no_data')" v-loading="loading" stripe style="width: 100%">
            <el-table-column prop="description" :label="i18n.tkey('lang_cn_name')" />
            <el-table-column prop="description2" :label="i18n.tkey('lang_en_name')" />
            <el-table-column :label="i18n.tkey('lang_operate')">
                <template #default="scope">
                    <el-button
                            size="small"
                            @click="clickEditBtn((scope.row))"
                    >
                        <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                    </el-button>

                    <el-button
                            size="small"
                            type="danger"
                            @click="delRecordConfirm(scope.row)"
                    >
                        <span><font-awesome-icon icon="fa-solid fa-trash-can" /></span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script setup>
    import {inject, onBeforeMount, ref, toRef} from "vue";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import {useCompanyinfo} from "@/stores/companyinfo";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faTrashCan, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";

    library.add(faTrashCan, faPenToSquare)

    const emits = defineEmits(["clickEditBtn"])

    const i18n = inject("i18n")

    const loading = ref(false)

    //響應機制的companyinfo
    const companyInfoRef = toRef(useCompanyinfo())

    const shopCompany = ref({})
    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return companyInfoRef.value } })

    const unitList = ref([])

    function getUnitCodeList(){
        loading.value = true

        const request = eshopopeeApi.getUnit
        const params = request.getParams()

        params.CompanyCode = shopCompany.value.acccompanycode

        request.send(params, (res) => {
            loading.value = false
            if (null != res){
                unitList.value = res
            }
        })

    }

    function delRecordConfirm(obj){
        myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
            delRecord(obj)
        })
    }

    function delRecord(obj){
        loading.value = true

        const request = eshopopeeApi.delUnit
        const params = request.getParams()

        params.CompanyCode = shopCompany.value.acccompanycode
        params.id = obj.id

        request.send(params, (res) => {
            myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
            getUnitCodeList()
        })

    }

    function clickEditBtn(obj){
        emits("clickEditBtn", obj)
    }

    onBeforeMount(() => {
        shopCompany.value = getShopCompanyObj()
        getUnitCodeList()
    })
</script>

<style scoped>

</style>